module.exports = __webpack_public_path__ + "img/guohuizu.6d2d9496.png";